import * as React from 'react';
import { Button, Box, makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Translation
} from '../../features/translations/getTranslation'

var boxStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%"
    }
})

export default function ConfirmDialog(props: any) {
    const boxStyle = boxStyles()

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (e: any) => {
        if (props.onClick && !props.onClick(e))
            return;
        setOpen(true);
    };

    const handleClose = (agreement: any) => {
        if (agreement === true) {
            if (props.agreeFunction !== undefined) props.agreeFunction()
        }
        else {
            if (props.disagreeFunction !== undefined) props.disagreeFunction()
        }
        setOpen(false);
    };
    return (
        <React.Fragment>
            <Box className={boxStyle.root + " " + props.className} onClick={handleClickOpen}>{props.children}</Box>
            <Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title">{Translation.t(props.header)}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {Translation.t(props.message)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)} color="primary"> {Translation.t("No")} </Button>
                    <Button onClick={() => handleClose(true)} color="secondary" autoFocus> {Translation.t("Yes")} </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}